<div class="text-center my-5">
  <fgbcl-loading></fgbcl-loading>
  <p class="my-2">
    <em>{{ 'registration.callback.title' | translate }}</em>
  </p>
  <p class="my-2 font-size-12">
    <em>{{ 'registration.callback.description' | translate }}</em>
  </p>
</div>
